import React from 'react';
import { LogOutIcon } from 'lucide-react';
import { cn } from '@rocco/utils/cn';
import { Button } from '@rocco/components/button';
import { AlertDialog } from '@rocco/ui/dialog/components/AlertDialog';

/**
 * The "Leave conversation" button in the chat box conversation settings "Settings" tab.
 */
export function ChatBoxSettingsLeaveButton({
    className,
    onConfirm,
    ...props
}: React.ComponentPropsWithoutRef<typeof Button> & {
    onConfirm: () => void;
}) {
    return (
        <AlertDialog
            title="Leave conversation"
            description="Are you sure you want to leave this conversation?"
            onConfirm={onConfirm}
            trigger={
                <Button
                    type="button"
                    className={cn(
                        'gap-[6px] rounded-none px-0 py-[2px] text-[14px] leading-tight hover:underline focus-visible:border-black/20',
                        className
                    )}
                    color="transparent"
                    weight="default"
                    {...props}
                >
                    <LogOutIcon className="size-[16px]" />
                    Leave conversation
                </Button>
            }
        />
    );
}
